<template>
    <div class="cz2__modal-popup cz2__modal-popup--reset">
        <div class="cz2__modal-popup__body">
            <focus-lock>
                <div class="cz2__modal-popup__content" tabindex="0">
                    <button class="cz2__modal-popup__close" :aria-label="$t('POPUP_CLOSE')" @click.prevent="close">
                    </button>

                    <div class="cz2__modal-popup__header">
                        {{$t('POPUP_RESET_HEADER')}}
                    </div>

                    <div class="cz2__modal-popup__body-copy">
                        {{$t('POPUP_RESET_BODY')}}
                    </div>

                    <div class="cz2__modal-popup__actions">
                        <button class="cz2__modal-popup__button cz2__modal-popup__button--ok" @click.prevent="confirm">
                            {{$t('POPUP_RESET_OK')}}
                        </button>

                        <button class="cz2__modal-popup__button cz2__modal-popup__button--cancel" @click.prevent="cancel">
                            {{$t('POPUP_RESET_CANCEL')}}
                        </button>
                    </div>
                </div>
            </focus-lock>
        </div>
    </div>
</template>

<script>
    import FocusLock from 'vue-focus-lock';

    export default {
        components: {
            FocusLock,
        },

        methods: {
            close() {
                this.$store.dispatch('showResetConfirmation', false);
            },

            cancel() {
                this.$store.dispatch('showResetConfirmation', false);
            },

            confirm() {
                this.$store.dispatch('resetCustomizations');
                this.$store.dispatch('showResetConfirmation', false);
            },
        },
    };
</script>
